import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ShieldAlert } from 'lucide-react';

// level 'secondary' (default): hiring, ordering and money steps. level 'basic': posting a job request or a gig.
const VerificationRequiredModal = ({ isOpen, onClose, returnUrl, level = 'secondary' }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const isBasic = level === 'basic';

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-in fade-in duration-200">
      <div 
        className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl relative animate-in slide-in-bottom-4 duration-300"
        onClick={e => e.stopPropagation()}
      >
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors z-10"
        >
          <X size={20} />
        </button>

        <div className="p-6">
          <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-5 mx-auto">
            <ShieldAlert size={32} className="text-blue-600" />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
            {isBasic ? 'Verify your email and phone' : 'Verification Required'}
          </h2>

          <p className="text-gray-600 text-center mb-6 text-sm">
            {isBasic
              ? 'To post on GigShip, verify your email address and phone number first.'
              : 'To maintain a secure and trusted community, you must complete Secondary Verification before proceeding.'}
          </p>

          <div className="space-y-3">
            <button
              onClick={() => {
                onClose();
                // Basic = verify email and phone (VerifyParallel); Settings' Basic tier has no verify action
                if (isBasic) navigate('/verify-parallel', { state: { autoSend: true, from: returnUrl } });
                else navigate('/dashboard/settings?tab=verification', { state: { from: returnUrl } });
              }}
              className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors shadow-sm"
            >
              Verify Now
            </button>
            <button
              onClick={onClose}
              className="w-full py-3 px-4 bg-gray-50 hover:bg-gray-100 text-gray-700 font-medium rounded-xl transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationRequiredModal;
